import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import FirebaseImage from 'components/FirebaseImage'
import Image from 'components/Image'

import styles from './ThumbnailSelectable.module.scss'

export default class ThumbnailSelectable extends React.Component {
  static propTypes = {
    active: PropTypes.bool,
    image: PropTypes.string,
    onClick: PropTypes.func,
  }

  //state = {
  //  active: false,
  //}

  handleClick = () => {
    const { onClick } = this.props

    //this.setState({ active: !this.state.active })

    if (onClick) onClick()
  }

  render() {
    const {
      active,
      //image = '//placehold.it/120x120',
      image,
    } = this.props
    //const { active } = this.state

    return (
      <button
        type="button"
        className={classNames('ThumbnailSelectable', styles.this, active && styles['this---active'])}
        onClick={this.handleClick}>
        {/*
        <div
          style={{ width: 120, height: 120, backgroundImage: `url(${image})` }}
          className={styles.img}
        />
        */}
        <FirebaseImage imageRef={image} thumbnail className={styles.img} style={{ width: 120, height: 120 }} />
        {/*<Image src={image} className={styles.img} style={{ width: 120, height: 120 }} />*/}
      </button>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/ThumbnailSelectable/ThumbnailSelectable.js